import moment from 'moment-timezone'
import * as blueprint from '@adc/blueprint'

export const getTimezoneAbbreviation = () => {
  const timezone = blueprint.utils.calculateTimeZone()
  return moment.tz(timezone).format('z')
}

const AUCTION_DURATION_START_DATE_TIME_FORMAT = 'MMM D, h:mma'
const AUCTION_DURATION_END_DATE_FORMAT = 'MMM D'

export const getAuctionDurationDisplayText = (
  startDateTime = '',
  endDateTime = ''
) => {
  const timezone = blueprint.utils.calculateTimeZone()
  const startDateTimeText = moment
    .tz(startDateTime, timezone)
    .format(AUCTION_DURATION_START_DATE_TIME_FORMAT)
  const endDateTimeText = moment
    .tz(endDateTime, timezone)
    .format(AUCTION_DURATION_END_DATE_FORMAT)
  const auctionDurationText = `${startDateTimeText} - ${endDateTimeText}`
  return auctionDurationText
}
